import React, { useRef } from "react";
import { Animated, Easing, Platform } from "react-native";
import styled, { useTheme } from "styled-components/native";
import { SpaceType } from "@components/atoms/Spacer/types";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { VDBIcons } from "@utils/VDBIcons";
import { ProductCategory } from "@utils/constants";
import { getProductThemeFromType } from "@components/common/Header/utils";
import { DefaultTheme } from "styled-components/native";

type ShowMoreButtonProps = {
  options: Array<any>;
  columns: number;
  displayedRows?: number;
  showAll: boolean;
  onPressFunction: Function;
  selectedProduct: ProductCategory;
};

const ShowMoreButton = ({
  options,
  columns,
  displayedRows,
  showAll,
  onPressFunction,
  selectedProduct,
}: ShowMoreButtonProps) => {
  const theme = useTheme();
  const productTheme = getProductThemeFromType(selectedProduct);

  const translateY = useRef(new Animated.Value(0)).current;

  const handleHoverIn = () => {
    Animated.timing(translateY, {
      toValue: showAll ? -4 : 4,
      duration: 200,
      easing: Easing.out(Easing.quad),
      useNativeDriver: Platform.OS !== "web",
    }).start();
  };

  const handleHoverOut = () => {
    Animated.timing(translateY, {
      toValue: 0,
      duration: 200,
      easing: Easing.out(Easing.quad),
      useNativeDriver: Platform.OS !== "web",
    }).start();
  };

  return (
    <>
      {!!displayedRows && options.length > displayedRows * columns && (
        <ShowMore
          onPress={() => onPressFunction(!showAll)}
          productTheme={productTheme}
          onHoverIn={handleHoverIn}
          onHoverOut={handleHoverOut}
        >
          <Animated.View style={{ transform: [{ translateY }] }}>
            <VDBIcon
              name={showAll ? VDBIcons.ARROW_UP : VDBIcons.ARROW_DOWN}
              size={24}
              color={
                theme[`${productTheme}-06` as keyof DefaultTheme] as string
              }
              variant={IconsVariant.VDBCustom}
            />
          </Animated.View>
        </ShowMore>
      )}
    </>
  );
};

const ShowMore = styled.Pressable<{
  productTheme: string;
}>`
  background-color: ${({
    theme,
    productTheme,
  }: {
    theme: DefaultTheme;
    productTheme: string;
  }) => theme[`${productTheme}-03` as keyof DefaultTheme] as string};
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  margin-top: ${SpaceType.Double}px;
`;

export default ShowMoreButton;
